import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import PostPoll from './components/PostPoll';
export default () => {
  extend(CommentPost.prototype, 'content', function (content) {
    const post = this.attrs.post;
    if ((!post.isHidden() || this.revealContent) && post.polls()) {
      for (const poll of post.polls()) {
        if (poll) {
          // JRH fork: onStateChange lets PostPoll punch through the
          // SubtreeRetainer below when its LOCAL state changes. A ranked
          // ballot is staged on the component (PollState.pendingOptions),
          // not in the store, so the retainer's store-only check never
          // sees it and prunes the redraw - clicks then look like no-ops.
          content.push(m(PostPoll, {
            post: post,
            poll: poll,
            onStateChange: () => this.subtree.invalidate()
          }));
        }
      }
    }
  });
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => {
      var _polls$map;
      const polls = this.attrs.post.polls();
      const checks = polls == null || (_polls$map = polls.map) == null ? void 0 : _polls$map.call(polls, poll => {
        var _poll$data, _poll$options$map, _poll$options, _poll$myVotes$map, _poll$myVotes;
        return poll && [(_poll$data = poll.data) == null ? void 0 : _poll$data.attributes, (_poll$options$map = (_poll$options = poll.options()).map) == null ? void 0 : _poll$options$map.call(_poll$options, option => {
          var _option$data;
          return option == null || (_option$data = option.data) == null ? void 0 : _option$data.attributes;
        }), // JRH fork: rank included, not just the option id - re-ranking
        // the same set of options changes no ids, so the retainer would
        // otherwise skip re-rendering the updated badges after a save.
        (_poll$myVotes$map = (_poll$myVotes = poll.myVotes()).map) == null ? void 0 : _poll$myVotes$map.call(_poll$myVotes, vote => {
          var _vote$option, _vote$rank, _vote$rank2;
          return "".concat((_vote$option = vote.option()) == null ? void 0 : _vote$option.id(), ":").concat((_vote$rank = (_vote$rank2 = vote.rank) == null ? void 0 : _vote$rank2.call(vote)) != null ? _vote$rank : '');
        })];
      });
      return JSON.stringify(checks);
    });
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    // @ts-ignore
    if (app.pusher) {
      // @ts-ignore
      app.pusher.then(binding => {
        // We will listen for updates to all polls and options
        // Even if that model is not in the current discussion, it doesn't really matter
        binding.channels.main.bind('updatedPollOptions', data => {
          const poll = app.store.getById('polls', data['pollId']);
          if (poll) {
            poll.pushAttributes({
              voteCount: data['pollVoteCount']
            });

            // Not redrawing here, as the option below should trigger the redraw already
          }
          const changedOptions = data['options'];
          for (const optionId in changedOptions) {
            const option = app.store.getById('poll_options', optionId);
            if (option && option.voteCount() !== undefined) {
              option.pushAttributes({
                voteCount: changedOptions[optionId]
              });
            }
          }
          m.redraw();
        });
      });
    }
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    // @ts-ignore
    if (app.pusher) {
      // @ts-ignore
      app.pusher.then(binding => {
        binding.channels.main.unbind('updatedPollOptions');
      });
    }
  });
};